import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';

// Includes the historical API/CDN prefix, but never matches ordinary filenames
// or text which happens to mention the censorship asset.
export function isCensoredImage(src) {
  if (typeof src !== 'string') return false;
  try { return /(?:^|\/)system\/bad\.jpg$/i.test(new URL(src.trim(), 'https://wiw.invalid/').pathname); }
  catch { return false; }
}

export function isUnavailableImage(src) {
  if (typeof src !== 'string') return false;
  try { return /(?:^|\/)(?:system\/moderation\.jpg|IMG\d+)$/i.test(new URL(src.trim(), 'https://wiw.invalid/').pathname); }
  catch { return false; }
}

export default function CensoredContent({ kind = 'image', unavailable = false, editable = false }) {
  const { t } = useTranslation('brand');
  const label = unavailable ? t('imageUnavailable', { defaultValue: 'Image unavailable' })
    : t('contentCensored', { defaultValue: 'Censured' });
  return <span className="censored-content" data-censored-kind={unavailable ? undefined : kind}
    data-media-unavailable={unavailable || undefined} role="img" aria-label={label}>
    <span aria-hidden="true">{label}</span>
    {unavailable && editable && <span className="censored-content__hint">{t('imageReplaceHint', {
      defaultValue: 'Remove this image and upload it again.' })}</span>}
  </span>;
}
